import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import { GoogleOAuthProvider } from '@react-oauth/google';
// MSAL restored: the API now verifies Microsoft ID tokens server-side
// (POST /api/auth/mstoken), mirroring the Google ssotoken flow.
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";

const msalInstance = new PublicClientApplication(msalConfig);


if (process.env.NODE_ENV === 'production') {

  disableReactDevTools();
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
}


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => console.log('SW registered: ', registration))
      .catch(registrationError => console.log('SW registration failed: ', registrationError));
  });
}



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="819239592244-05ina5e64o2o9laaci66k3lor5bic99c.apps.googleusercontent.com">
  <MsalProvider instance={msalInstance}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </MsalProvider>
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
